export const mailModuleName = "EysMke";
export default {mailModuleName};